export enum HtmlStorageLocation {
  Local = "local",
  Memory = "memory",
  Session = "session",
}
